import { AUDIENCE_TYPE } from 'Routes/MyCourses/Domain/constants';
import { PROVIDER_NAME, PROVIDER_NAME_SHORT_HAND } from 'Util/constants';

const priorityAudienceType = {
  [AUDIENCE_TYPE.GLOBAL]: 1,
  [AUDIENCE_TYPE.PROVIDER]: 2,
  [AUDIENCE_TYPE.COURSE]: 3,
  [AUDIENCE_TYPE.USER]: 4,
};

const filterUnReadAnnouncement = (announcements, readPopups) => {
  return announcements.filter((announcement) => {
    return !readPopups.includes(announcement?.id);
  });
};

const sortPriorityAnnouncement = (announcement) => {
  return announcement.sort((a, b) => {
    const priorityA = priorityAudienceType[a.relationType];
    const priorityB = priorityAudienceType[b.relationType];
    if (priorityA - priorityB !== 0) {
      return priorityA - priorityB;
    }
    return new Date(b.createdAt) - new Date(a.createdAt);
  });
};

export const getPrioritizedAnnouncement = (announcements = [], readPopups = []) => {
  const filteredUnReadAnnouncement = filterUnReadAnnouncement(announcements, readPopups);
  const sortedPriorityAnnouncement = sortPriorityAnnouncement(filteredUnReadAnnouncement);
  return sortedPriorityAnnouncement[0];
};

export const calculateMarkAsReadStatus = (markAsReadStatus, isShowPopupAnnouncement) => {
  if (markAsReadStatus.isCheckDoNotShowAgain) {
    return Object.values(markAsReadStatus).indexOf(true) > -1;
  } else {
    return Object.values(markAsReadStatus).indexOf(true) > -1 && isShowPopupAnnouncement;
  }
};

const getProviderNameShortHand = (providerName) => {
  if (providerName === PROVIDER_NAME.ONDEMAND) {
    return PROVIDER_NAME_SHORT_HAND.ONDEMAND;
  } else {
    return PROVIDER_NAME_SHORT_HAND.LEARNED;
  }
};

export const getAnnouncementEventLabel = (providerName, campaignName) => {
  const providerNameShortHand = getProviderNameShortHand(providerName);
  const announcementEventLabel = `${providerNameShortHand}-${campaignName}`;
  return announcementEventLabel;
};
